export function transformData(obj) {
  return obj.data.map(item => {
    const transformedItem = {};
    obj.columns.forEach((column, index) => {
      transformedItem[column] = item[index];
    });
    return transformedItem;
  });
}

export function createNestedCategories(data) {
  const nestedCategories = [];
  const categoryMap = {};

  // First, create a mapping of id -> category object
  for (const category of data) {
    category.sub = [];
    categoryMap[category.id] = category;
  }

  // Now, iterate through the categories and assign the children to the correct parents
  for (const category of data) {
    if (!category.parent_id) {
      nestedCategories.push(category);
    } else {
      const parent = categoryMap[category.parent_id];
      if (parent) {
        parent.sub.push(category);
      }
    }
  }

  return nestedCategories;
}

export function transformStatsOrder(arr) {
  const statusMapping = {
    0: 'pending',
    1: 'accepted',
    2: 'rejected',
    3: 'delivered',
    4: 'delivery_rejected',
    5: 'completed',
  };
  const output = {};

  arr.forEach(item => {
    output[statusMapping[item.status]] = item.total;
  });

  return output;
}

export function findCategoryById(categories, id) {
  for (const category of categories) {
    if (category.id === id) {
      return category;
    }

    if (category.sub.length > 0) {
      const foundCategory = findCategoryById(category.sub, id);
      if (foundCategory) {
        return foundCategory;
      }
    }
  }
  return null;
}
